// ligfrontend/src/components/Lig/YearSelector.js
import React from "react";
import "./YearSelector.css";

const YearSelector = ({ years, selectedYear, onYearChange }) => {
  return (
    <div className="year-selector">
      <label htmlFor="year-select" className="year-label">
        View Year:
      </label>
      <select
        id="year-select"
        className="year-select"
        value={selectedYear || ""}
        onChange={(e) => onYearChange(Number(e.target.value))}
      >
        <option value="">All Time</option>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );
};

export default YearSelector;
